import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterSidebar = ({ filters, onFilterChange, onClearFilters }) => {
  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'pending', label: 'Pending' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const urgencyOptions = [
    { value: 'all', label: 'All Urgencies' },
    { value: 'Emergency', label: 'Emergency' },
    { value: 'Scheduled', label: 'Scheduled' }
  ];

  const issueTypeOptions = [
    { value: 'all', label: 'All Issue Types' },
    { value: 'Mechanical', label: 'Mechanical' },
    { value: 'Electrical', label: 'Electrical' },
    { value: 'Safety', label: 'Safety' },
    { value: 'Routine Maintenance', label: 'Routine Maintenance' },
    { value: 'Other', label: 'Other' }
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'Last 7 Days' },
    { value: 'month', label: 'Last 30 Days' }
  ];

  const technicianOptions = [
    { value: 'all', label: 'All Technicians' },
    { value: 'unassigned', label: 'Unassigned' },
    { value: 'tech-001', label: 'Mike Johnson' },
    { value: 'tech-002', label: 'Sarah Williams' },
    { value: 'tech-003', label: 'David Chen' },
    { value: 'tech-004', label: 'Lisa Martinez' }
  ];

  const hasActiveFilters =
    filters?.search?.trim() ||
    filters?.status !== 'all' ||
    filters?.urgency !== 'all' ||
    filters?.issueType !== 'all' ||
    filters?.dateRange !== 'all' ||
    filters?.technician !== 'all';

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-1 h-full overflow-y-auto">
      <div className="sticky top-0 bg-card border-b border-border px-4 py-3 z-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="Filter" size={20} color="var(--color-primary)" strokeWidth={2} />
            <h3 className="text-sm font-semibold text-foreground">Filters</h3>
          </div>
          {hasActiveFilters && (
            <button
              onClick={onClearFilters}
              className="text-xs text-primary hover:text-primary/80 font-medium transition-hover"
            >
              Clear All
            </button>
          )}
        </div>
      </div>

      <div className="p-4 space-y-6">
        {/* Search */}
        <div>
          <Input
            type="search"
            label="Search Requests"
            placeholder="Request ID, phone, unit..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="mb-0"
          />
        </div>

        {/* Status Filter */}
        <div>
          <Select
            label="Status"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFilterChange('status', value)}
          />
        </div>

        {/* Urgency Filter */}
        <div>
          <Select
            label="Urgency"
            options={urgencyOptions}
            value={filters?.urgency}
            onChange={(value) => onFilterChange('urgency', value)}
          />
        </div>

        {/* Issue Type Filter */}
        <div>
          <Select
            label="Issue Type"
            options={issueTypeOptions}
            value={filters?.issueType}
            onChange={(value) => onFilterChange('issueType', value)}
          />
        </div>

        {/* Date Range Filter */}
        <div>
          <Select
            label="Date Range"
            options={dateRangeOptions}
            value={filters?.dateRange}
            onChange={(value) => onFilterChange('dateRange', value)}
          />
        </div>

        {/* Technician Filter */}
        <div>
          <Select
            label="Assigned Technician"
            options={technicianOptions}
            value={filters?.technician}
            onChange={(value) => onFilterChange('technician', value)}
          />
        </div>

        {/* Filter Info */}
        <div className="pt-4 border-t border-border">
          <div className="flex items-start space-x-2">
            <Icon name="Info" size={16} color="var(--color-primary)" strokeWidth={2} className="flex-shrink-0 mt-0.5" />
            <p className="text-xs text-muted-foreground">
              Use filters to narrow down service requests. Real-time updates will reflect new submissions automatically.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;